import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const GroupsIcon = forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path
      fillRule="evenodd"
      d="M9 2a5 5 0 1 0 0 10A5 5 0 0 0 9 2ZM6 7a3 3 0 1 1 6 0 3 3 0 0 1-6 0Z"
      clipRule="evenodd"
    />
    <path d="M6 14a5 5 0 0 0-5 5v2a1 1 0 1 0 2 0v-2a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3v2a1 1 0 1 0 2 0v-2a5 5 0 0 0-5-5H6Zm12 .9a1 1 0 0 1 1.3-.7A5 5 0 0 1 23 19v2a1 1 0 1 1-2 0v-2a3 3 0 0 0-2.3-2.9 1 1 0 0 1-.7-1.2ZM16.2 2.2a1 1 0 1 0-.4 1.9 3 3 0 0 1 0 5.8 1 1 0 1 0 .4 2 5 5 0 0 0 0-9.7Z" />
  </Icon>
));
export default GroupsIcon;
